<template>
    <div id="renterContact">
        <hr class="solid">
        <div class="row">
            <div class="col-md-12">
                <h3 class="mb-3 mt-2" style="margin-bottom: 30px !important;">{{ $t('components.renterContact.title') }}</h3>
            </div>
        </div>
        <div class="row" id="contactContainer">
            <div class="col">
                <div class="feature-box feature-box-style-2">
                    <div class="feature-box-icon pt-0">
                        <i class="icon-location-pin icons"></i>
                    </div>
                    <div class="feature-box-info" style="white-space: pre; padding-left: 5px;">
                        <h4 class="mb-2">{{ $t('components.renterContact.address') }}</h4>
                        <p class="text-4" v-html="computeAddress"></p>
                    </div>
                </div>
            </div>
            <div class="col" v-if="phoneNumbers && phoneNumbers.length > 0">
                <div class="feature-box feature-box-style-2">
                    <div class="feature-box-icon pt-0">
                        <i class="icon-phone icons"></i>
                    </div>
                    <div class="feature-box-info" style="padding-left: 5px;">
                        <h4 class="mb-2">{{ $t('components.renterContact.phoneNumber') }}</h4>
                        
                        <p class="text-4">
                            <UnstyledList :entries="phoneNumbers"></UnstyledList>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-box feature-box-style-2">
                    <div class="feature-box-icon pt-0">
                        <i class="icon-envelope icons"></i>
                    </div>
                    <div class="feature-box-info" style="padding-left: 5px;">
                        <h4 class="mb-2">{{ $t('components.renterContact.email') }}</h4>
                        <p class="text-4">
                            <a :href="`mailto:${computeEmail}?subject=${computeObject}`"> {{ computeEmail }}</a>
                        </p>
                    </div>
                </div>
                <div class="feature-box feature-box-style-2" v-if="this.owner.type === 'COMPANY' && this.owner.url">
                    <div class="feature-box-icon pt-0">
                        <i class="icon-globe icons"></i>
                    </div>
                    <div class="feature-box-info">
                        <h4 class="mb-2">{{ $t('components.renterContact.url') }}</h4>
                        <p class="text-4">
                            <a :href="this.owner.url">{{ this.owner.url }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import UnstyledList from "@/components/common/UnstyledList";
export default {
    name: 'RenterContact',
    components: {
        UnstyledList
    },
    props: {
        listing: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.$http.get(`/listings/${this.listing.id}/owner`)
            .then(res => {
                // TODO: Check if this is enough or it should be expanded
                this.owner = res.data;
            }).catch(err => {
                console.log("Error fetching owner");
            })
    },
    computed: {
        computeAddress: function() {
            if (this.isUndefined(this.owner)) {
                return "";
            }

            return this.owner.userInfo.split("\n").filter(el => el.indexOf("null") == -1).join("\n");
        },
        phoneNumbers: function() {
            if (this.isUndefined(this.owner)) {
                return [];
            }

            let iconMap = {
                "MOBILE": "fa-mobile-alt",
                "FIXED": "fa-home",
                "FAX": "fa-fax"
            }

            let typeMap = {
                "MOBILE": this.$i18n.t('components.renterContact.mobile'),
                "FIXED": this.$i18n.t('components.renterContact.fixed'),
                "FAX": this.$i18n.t('components.renterContact.fax'),
            }

            return this.owner.phoneNumberList.map(el => {
                return {
                    icon: iconMap[el.type],
                    tooltip: typeMap[el.type],
                    content: el.number,
                    additional: el.notes
                }
            });
        },
        computeEmail: function() {
            if (this.isUndefined(this.owner)) {
                return "";
            }
            return this.owner.email
        },
        computeObject: function() {
            return `Anfrage für Objekt Nr. ${this.listing.objectId} / Richiesta per oggetto ${this.listing.objectId}`
        }
    },
    data() {
        return {
            owner: {}
        }
    }
}
</script>

<style lang="scss" scoped>
#renterContact {
    margin-bottom: 32px;
}

h4 { 
    font-family: "Noto Serif SC", serif;
    font-weight: 500;
}
</style>
